import React, { useMemo, useRef } from "react";
import { Card, Button } from "react-bootstrap";
import { AccessLogFilter } from "./accessLog-filter/AccessLogFilter";
import { AccessLogTable } from "./accessLog-table/AccessLogTable";
import { useAccessLogUIContext } from "./AccessLogUIContext";

export function AccessLogCard({
  isLoading,
  filterValues,
  handleFilterValues,
  handleAddAccessLogShow,
  accessLogListTotalCount,
  currentPage,
  setCurrentPage,
  accessLogList,
  handleReset
}) {
  const accessLogUIContext = useAccessLogUIContext();
  const accessLogUIProps = useMemo(() => {
    return {
      ids: accessLogUIContext.ids,
      queryParams: accessLogUIContext.queryParams,
      setQueryParams: accessLogUIContext.setQueryParams,
      openReceiptDialog: accessLogUIContext.openReceiptDialog,
      openDeleteDialog: accessLogUIContext.openDeleteDialog,
      openEditDialog: accessLogUIContext.openEditDialog,
    };
  }, [accessLogUIContext]);
  const myRef = useRef(null);
  const onhandleReset = () => {
    myRef.current.click();
  };

  return (
    <>
      <Card className="card-custom card-stretch make-payment-wrapper">
        <Card.Header className="align-items-center border-bottom mt-4 d-none d-lg-flex">
          <h3 className="card-title align-items-start flex-column">
            <span className="font-weight-bold text-dark">Access Logs</span>
          </h3>
          <Button
            type="button"
            className="btn btn-secondary btn-lg"
            onClick={onhandleReset}
          >
            Reset
          </Button>
          <Button
            variant="btn btn-light-primary btn-lg d-none"
            onClick={handleAddAccessLogShow}
          >
            New AccessLog
          </Button>
        </Card.Header>
        <Card.Body>
          <AccessLogFilter
            filterValues={handleFilterValues}
            myRef={myRef}
            handleReset={handleReset}
          />
          <AccessLogTable
            filterValues={filterValues}
            accessLogListTotalCount={accessLogListTotalCount}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            accessLogList={accessLogList}
            isLoading={isLoading}
          />
        </Card.Body>
      </Card>
    </>
  );
}
